import React from 'react'
import { Base, PrivacyPolicyContent } from '../components'
import { PAGES } from '../utils'

const PrivacyPolicy = (): JSX.Element => {
  const PRIVACY_POLICY = PAGES.PRIVACY_POLICY
  return (
    <Base
      headKey={PRIVACY_POLICY.HEAD_KEY}
      title={PRIVACY_POLICY.TITLE}
      metaDescription={PRIVACY_POLICY.DESCRIPTION}
      breadcrumbs={PRIVACY_POLICY.BREADCRUMBS}
    >
      <PrivacyPolicyContent />
    </Base>
  )
}

export default PrivacyPolicy
